<div class="modal-header">
  <h4 class="modal-title"></h4>
  <button type="button" class="close" aria-label="Close" (click)="hideModal()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">

  <!-- <app-ecom-item-upsell-grid [itemIds]="[+this.webstorage.sessionSt_item_selected.item_pkid]"></app-ecom-item-upsell-grid> -->
  <app-ecom-item-details2 [item]="item" [onClose]="onClose" [item_pkid]="item_pkid" [iscvsd_pkid]="iscvsd_pkid"
    [category_pkid]="category_pkid" [upSellId]="upSellId"></app-ecom-item-details2>

</div>
<!-- <div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="hideModal()">Đóng</button>
</div> -->